import { defineStore } from 'pinia';
import CartService from '@/services/CartService';

export const cartStore = defineStore('cart', {
  state: () => {
    return {
      cart: {},
      loading: false,
    };
  },
  actions: {
    getCart() {
      this.loading = true;
      return CartService.getCart().then((res) => {
        this.cart = res.data;
        this.loading = false;
        return this.cart;
      });
    },
    setCart(cart) {
      this.cart = cart;
    },
    addToCart(type, item) {
      if (!this.cart[type]) {
        this.cart[type] = [];
      }
      this.cart[type].push(item);
    },
    removeEventFromCart(eventId) {
      if (this.cart.ticket && this.cart.ticket.length > 0) {
        const indicies = [];
        this.cart.ticket.forEach((ticket, index) => {
          if (ticket.event.id === eventId) {
            indicies.push(index);
          }
        });
        indicies.reverse();
        indicies.forEach((index) => {
          this.cart.ticket.splice(index, 1);
        });
      }
    },
    saveCart() {
      this.cart.error = null;
      return CartService.save(this.cart).then((res) => {
        if (res.data.cartError !== null) {
          this.cart = {
            error: res.data.cartError,
          };
        }
        return res.data;
      });
    },
    submitOrder(checkout) {
      return CartService.createOrder(checkout);
    },
  },
});
